var _polygon, _line, _g, _g2, _g3, _polygon2, _polygon3, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMountMoulding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "700px",
    height: "775.3px",
    viewBox: "0 0 700 775.3",
    enableBackground: "new 0 0 700 775.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#EDEDED",
    points: "697.6,774.1 2.4,775.3 2.4,0 697.6,0 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 700,
    y1: 740.2,
    x2: 0,
    y2: 740.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 209.9,
    y: 142.7,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 3,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 165.8,
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    width: 234,
    height: 342.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9674,
    strokeMiterlimit: 10,
    d: "M218.2,751c0,0-7.7,8.5-15.6,8.6 c-7.9,0.1-14.6-7.6-14.6-7.6V28.9c0,0,4.9,0,15.1,0s15.1,0,15.1,0V751z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9667,
    strokeMiterlimit: 10,
    d: "M188,752.1c-6.8-2.7-10.4,1-10.4,1 s-4.5,6.5-10.9,6.5c-8,0-13.2-7.6-13.2-7.6V28.9H188V752.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9667,
    strokeMiterlimit: 10,
    d: "M153.5,752.1c-6.8-2.7-10.4,1-10.4,1 s-4.5,6.5-10.9,6.5c-8,0-13.2-7.6-13.2-7.6V28.9h34.5V752.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9667,
    strokeMiterlimit: 10,
    d: "M119,752.1c-6.8-2.7-10.4,1-10.4,1 s-4.5,6.5-10.9,6.5c-8,0-13.2-7.6-13.2-7.6V28.9H119V752.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9674,
    strokeMiterlimit: 10,
    d: "M480.1,751c0,0,7.7,8.5,15.6,8.6 c7.9,0.1,14.6-7.6,14.6-7.6V28.9c0,0-4.9,0-15.1,0s-15.1,0-15.1,0V751z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9667,
    strokeMiterlimit: 10,
    d: "M510.3,752.1c6.8-2.7,10.4,1,10.4,1 s4.5,6.5,10.9,6.5c8,0,13.2-7.6,13.2-7.6V28.9h-34.5V752.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9667,
    strokeMiterlimit: 10,
    d: "M544.8,752.1c6.8-2.7,10.4,1,10.4,1 s4.5,6.5,10.9,6.5c8,0,13.2-7.6,13.2-7.6V28.9h-34.5V752.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9667,
    strokeMiterlimit: 10,
    d: "M579.3,752.1c6.8-2.7,10.4,1,10.4,1 s4.5,6.5,10.9,6.5c8,0,13.2-7.6,13.2-7.6V28.9h-34.5V752.1z"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B2B2B2",
    stroke: "#717070",
    strokeWidth: 0.6357,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 678.3,41.7 687.7,41.7 700,32.1 614.1,32.1 614.2,41.7 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B2B2B2",
    stroke: "#717070",
    strokeWidth: 0.6357,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 84.8,41.7 84.9,32.1 0,32.1 12.3,41.7 21.7,41.7 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#C6C6C6",
    stroke: "#717070",
    strokeWidth: 0.748,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 700,
    height: 32.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountMoulding);
export default __webpack_public_path__ + "static/media/mount_moulding.35742f065776d8867f235a241d8e3814.svg";
export { ForwardRef as ReactComponent };